export const API_GATEWAY_BASE_URL = process.env.REACT_APP_API_BASE_URL;
